import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { logWarning } from "@faire/web--source/common/logging";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { hasLocale } from "@faire/web--source/ui/routing/util";
import trackClick from "@faire/web-api--source/api/click-track/post";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React, { useCallback, useContext } from "react";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
export var TrackedLinkContext = /*#__PURE__*/ React.createContext(undefined);
export var TrackedLink = function(props) {
    var to = props.to, children = props.children, linkProps = _object_without_properties(props, [
        "to",
        "children"
    ]);
    var clickInfo = useContext(TrackedLinkContext);
    var handleClick = useCallback(function(event) {
        if (clickInfo !== undefined) {
            trackClick(IClickInfo.build({
                token: props.token,
                type: clickInfo.type,
                container_name: clickInfo.containerName,
                request_id: clickInfo.requestId || ""
            }));
        } else {
            logWarning(new Error("TrackedLink component clicked outside of TrackedLinkContext.Provider!"));
        }
        if (props.onClick) {
            props.onClick(event);
        }
    }, [
        clickInfo,
        props
    ]);
    if (to === undefined) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    if (clickInfo === undefined) {
        return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
            "data-test-id": "tracked-link-no-info",
            to: to
        }, linkProps), {
            children: children
        }));
    }
    /**
     * Skip prepending the locale to path if it is a logged-out product click
     * to prevent random scrolling to the top if the path does not link to a new page.
     * prerender should still get locale prepended to path.
     */ var shouldSkipPrependLocale = !isLoggedInRetailer() && !isPrerender() && (clickInfo === null || clickInfo === void 0 ? void 0 : clickInfo.type) === IClickInfo.Type.PRODUCT ? !hasLocale(to) : false;
    return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
        to: to,
        skipPrependLocale: shouldSkipPrependLocale
    }, linkProps), {
        onClick: handleClick,
        children: children
    }));
};
export var withTrackedLink = function(Comp) {
    return function withTrackedLink(props) {
        return /*#__PURE__*/ _jsx(TrackedLinkContext.Consumer, {
            children: function(value) {
                return /*#__PURE__*/ _jsx(Comp, _object_spread({}, value, props));
            }
        });
    };
};
